export interface CollectionRequest {
  debtId: string;
  amount: number;
  date: string;
  receipt?: string;
  account?: string;
  requestId: string;
}

type RequestStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;
const storageKey = (debtId: string) => `life-os:pending-collection:${debtId}`;

// Keep the submission with its identity before the network call. Closing the
// detail or reloading a tab can then retry an uncertain response safely.
export function pendingCollection(debtId: string, storage: RequestStorage = sessionStorage): CollectionRequest | null {
  try {
    const request = JSON.parse(storage.getItem(storageKey(debtId)) || "null") as CollectionRequest | null;
    if (request?.debtId !== debtId || typeof request.requestId !== "string" || !request.requestId.startsWith(debtId + ":")
      || !Number.isFinite(request.amount) || request.amount <= 0 || typeof request.date !== "string") return null;
    return request;
  } catch { return null; }
}

export function retainCollectionRequest(input: Omit<CollectionRequest, "requestId">, storage: RequestStorage = sessionStorage, createId = () => crypto.randomUUID()): CollectionRequest {
  const previous = pendingCollection(input.debtId, storage);
  const request = { ...input, requestId: previous?.requestId || `${input.debtId}:${createId()}` };
  storage.setItem(storageKey(input.debtId), JSON.stringify(request));
  return request;
}

export function confirmCollectionRequest(request: CollectionRequest, storage: RequestStorage = sessionStorage): void {
  if (pendingCollection(request.debtId, storage)?.requestId === request.requestId) storage.removeItem(storageKey(request.debtId));
}


// Explicit logout discards financial drafts. Authentication renewal keeps them.
export function clearCollectionRequests(storage: RequestStorage & Partial<Pick<Storage, "length" | "key">> = sessionStorage): void {
  if (!storage.key || storage.length === undefined) return;
  const keys: string[] = [];
  for (let i = 0; i < storage.length; i++) { const key = storage.key(i); if (key?.startsWith("life-os:pending-collection:")) keys.push(key); }
  for (const key of keys) storage.removeItem(key);
}
